module.exports = __webpack_public_path__ + "img/oa-icon.20d18ee5.svg";